module.exports = __webpack_public_path__ + "static/media/wizualizacja-115.f4ed4ff7.png";